import {
  ParagraphSectionLayout,
  ParagraphTitle,
  TableContainer,
  TableRowContainer,
  TableShellTitle,
  TableShellValue,
} from "@frontend/common";

import EditableTextContainer from "@EditArticleContainer/shared/components/EditableTextContainer/EditableTextContainer";
import { DEALS_PARAGRAPH_CODE } from "@EditArticleContainer/shared/constants/editArticle.constants";
import { useParagraphEditedData } from "@EditArticleContainer/shared/hooks/useParagraph";
import { useUpdateParagraph } from "@EditArticleContainer/shared/hooks/useUpdateParagraph";
import {
  REF_CODE_KEY_RIGHTS_MA_DRUG,
  REF_CODE_KEY_RIGHTS_MA_INDICATION,
} from "@EditArticleContainer/shared/libs/refCode/constants/refCode.constants";
import { createRefCode } from "@EditArticleContainer/shared/libs/refCode/utils/createRefCode";

import * as S from "./DealsParagraphKeyRightsMA.style";
import {
  drugLabels,
  drugText,
  indicationLabels,
  indicationText,
} from "./utils/getKeyRightsMAShellValue";

const PARAGRAPH_TITLE = "Key Rights";
const VALUE_SHELL_PADDING = "0.2rem";
const EDITABLE_TEXT_STYLE = { padding: "0.8rem", borderRadius: "0" };

const DealsParagraphKeyRightsMA = () => {
  const paragraph = useParagraphEditedData(DEALS_PARAGRAPH_CODE.keyRightsMA);
  const [updateParagraph, loadingIndex, updateKeyMap] = useUpdateParagraph({
    paragraphCode: DEALS_PARAGRAPH_CODE.keyRightsMA,
    sectionCode: "TY002",
  });

  if (!paragraph) return null;

  const rightsScopeTable = paragraph.text["Rights Scope"];

  if (rightsScopeTable.length === 0) return null;

  return (
    <ParagraphSectionLayout className="sub-section-wrapper">
      <ParagraphTitle title={PARAGRAPH_TITLE} type="section" />
      <S.FlowRow>
        <S.AxisChipsGroup>
          <S.AxisChip>
            Partner A<S.AxisRole>(Target Company)</S.AxisRole>
          </S.AxisChip>
          &apos;s
        </S.AxisChipsGroup>
      </S.FlowRow>
      <S.ParagraphKeyRightsMAWrapper key={updateKeyMap.get(0)}>
        <S.ParagraphKeyRightsMAUpdateButton
          disabled={loadingIndex === 0}
          onClick={() => updateParagraph(0)}
        />
        <TableContainer>
          <TableRowContainer>
            <TableShellTitle>Asset(s)</TableShellTitle>
            <TableShellTitle>Intended Use</TableShellTitle>
          </TableRowContainer>
          {rightsScopeTable.map((item, index) => (
            <TableRowContainer key={`key-rights-ma-${String(index)}`}>
              <TableShellValue padding={VALUE_SHELL_PADDING}>
                <EditableTextContainer
                  item={{
                    text: drugText(item),
                    labels: drugLabels(item),
                  }}
                  refKey={createRefCode(REF_CODE_KEY_RIGHTS_MA_DRUG, index)}
                  canTextEdit
                  style={EDITABLE_TEXT_STYLE}
                />
              </TableShellValue>
              <TableShellValue padding={VALUE_SHELL_PADDING}>
                <EditableTextContainer
                  item={{
                    text: indicationText(item),
                    labels: indicationLabels(item),
                  }}
                  refKey={createRefCode(
                    REF_CODE_KEY_RIGHTS_MA_INDICATION,
                    index,
                  )}
                  canTextEdit
                  style={EDITABLE_TEXT_STYLE}
                />
              </TableShellValue>
            </TableRowContainer>
          ))}
        </TableContainer>
      </S.ParagraphKeyRightsMAWrapper>
    </ParagraphSectionLayout>
  );
};

export default DealsParagraphKeyRightsMA;
